import { defineMessages } from 'react-intl';

export default defineMessages({
  btnEdit: {
    id: 'employeeRoleDetail.btn.edit',
    defaultMessage: 'Edit',
  },
  btnBack: {
    id: 'employeeRoleDetail.btn.back',
    defaultMessage: 'Back',
  },
  breadcrumbRoleList: {
    id: 'employeeRoleDetail.breadcrumb.roleList',
    defaultMessage: 'Employee Role List',
  },
  breadcrumbRoleDetail: {
    id: 'employeeRoleDetail.breadcrumb.roleDetail',
    defaultMessage: 'Employee Role Detail',
  },
  employeeRoleDetailTitle: {
    id: 'employeeRoleDetail.title',
    defaultMessage: 'Employee Roles Details',
  },
  labelRoleName: {
    id: 'employeeRoleDetail.label.employeeRoleName',
    defaultMessage: 'Employee Role Name',
  },
  labelRoleDescription: {
    id: 'employeeRoleDetail.label.employeeRoleDescription',
    defaultMessage: 'Employee Role Description',
  },
  labelCompanyRole: {
    id: 'employeeRoleDetail.label.companyRole',
    defaultMessage: 'Company Role',
  },
  labelEmployeePermission: {
    id: 'employeeRoleDetail.label.employeePermission',
    defaultMessage: 'Employee Permission',
  },
  labelSection: {
    id: 'employeeRoleDetail.label.section',
    defaultMessage: 'Section',
  },
  labelPermission: {
    id: 'employeeRoleDetail.label.permission',
    defaultMessage: 'Permission',
  },
  labelAction: {
    id: 'employeeRoleDetail.label.action',
    defaultMessage: 'Action',
  },
  labelModule: {
    id: 'employeeRoleDetail.label.module',
    defaultMessage: 'Module',
  },
  labelSubModule: {
    id: 'employeeRoleDetail.label.subModule',
    defaultMessage: 'Sub-Module',
  },
  labelCreate: {
    id: 'employeeRoleDetail.label.create',
    defaultMessage: 'Create',
  },
  labelRead: {
    id: 'employeeRoleDetail.label.read',
    defaultMessage: 'Read',
  },
  labelUpdate: {
    id: 'employeeRoleDetail.label.update',
    defaultMessage: 'Update',
  },
  labelDelete: {
    id: 'employeeRoleDetail.label.delete',
    defaultMessage: 'Delete',
  },
});
